import styled from 'styled-components'
import { DefaultFontStyle } from '../../styles/global-styles'
import { Card } from '../atoms/Card/card-styles'

interface BinProps {
  disabled?: boolean
}

export const BookingSubheading = styled.h3`
  ${DefaultFontStyle};
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: ${props => props.theme.colours.charcoal};
  margin-bottom: 15px;
  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    font-family: 'Roboto';
  }
  @media (min-width: ${props => props.theme.breakpoints.lg}px) {
    font-size: 16px;
    line-height: 24px;
  }
`

export const BookingListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin: 26px 0px 14px;
  @media (min-width: ${props => props.theme.breakpoints.lg}px) {
    margin: 42px 0px 14px;
    gap: 26px;
  }
`

export const BookingCard = styled(Card)`
  background: ${props => props.theme.colours.white};
  box-shadow: -4px 0px 0px ${props => props.theme.colours.red}, ${props => props.theme.boxShadow};
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 8px 15px;
  @media (min-width: ${props => props.theme.breakpoints.lg}px) {
    box-shadow: -8px 0px 0px ${props => props.theme.colours.red}, ${props => props.theme.boxShadow};
    padding: 9px 32px 13px;
  }
  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    border-radius: 6px;
  }
`

export const GroupBookingCard = styled(Card)`
  background: ${props => props.theme.colours.white};
  box-shadow: -4px 0px 0px ${props => props.theme.colours.yellow}, ${props => props.theme.boxShadow};
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  padding: 8px 15px;
  @media (min-width: ${props => props.theme.breakpoints.lg}px) {
    box-shadow: -8px 0px 0px ${props => props.theme.colours.yellow},
      ${props => props.theme.boxShadow};
    padding: 9px 32px 13px;
  }
  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    border-radius: 6px;
  }
`

export const Bin = styled.img<BinProps>`
  opacity: ${props => (props.disabled ? '0%' : '100%')};
  margin: 10px 10px 10px 5px;
  &:hover,
  &:focus {
    cursor: ${props => (props.disabled ? '' : 'pointer')};
    opacity: ${props => (props.disabled ? '0%' : '100%')};
  }

  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    width: 14px;
    margin: 10px 10px 7px 5px;
  }
`

export const BookingWrapperSingle = styled.div`
  display: flex;
  flex-direction: row;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  row-gap: 100px;
  margin: 26px 0px 0px;
  align-content: baseline;
`

export const BookingWrapperGroup = styled.div`
  display: flex;
  flex-direction: row;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  row-gap: 100px;
  margin: 26px 0px 0px;
  align-content: baseline;
`
export const BookingImgSingle = styled.img`
  width: 50px;
  height: 27px;
  margin: 10px -1px 0px;
  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    width: 35px;
    height: 20px;
    margin: 6px;
    padding-left: 6px;
    margin-top: 12px;
  }
`
export const BookingImgGroup = styled.img`
  width: 50px;
  height: 27px;
  margin: 10px -1px 0px;
  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    width: 35px;
    height: 20px;
    margin: 6px;
    padding-left: 6px;
    margin-top: 12px;
  }
`
export const BookingLabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 23px;
  justify-content: flex-end;
  margin-top: -76px;
  padding-right: 20px;
  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    padding-right: 10px;
    gap: 10px;
  }
  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    margin-top: -30px;
    padding-right: 20px;
    gap: 20px;
  }
  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    display: flex;
    justify-content: center;
    padding: 0px;
  }
`
export const BookingTypeLabel = styled.h3`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`
export const GroupBookingInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  width: 100%;
  margin-top: 20px;
`
export const GroupBookingHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  width: 100%;
`
export const NumberOfAttendees = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
`
export const NumberOfAttendeesText = styled.div`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
`
